import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Select, Select$} from '@angular-redux3/store';
import {toArray} from '../../utils';
import {Observable} from 'rxjs';
import {EventFamily, Tempo, TimeSlot} from '../../store/entities';

@Component({
  selector: 'mwo-playlist-folder-display',
  templateUrl: './playlist-folder-display.component.html',
  styleUrls: ['./playlist-folder-display.component.scss']
})
export class PlaylistFolderDisplayComponent implements OnInit {

  @Select$('playlistsMw', toArray) playlistMw$: Observable<EventFamily[]>;
  playlistsFamilies: EventFamily[];
  @Select(state => state.playrules.playrules) playrules$: Observable<Tempo[]>;
  playrules: Tempo[];

  @Output() onPlaylistSelected = new EventEmitter<EventFamily>();
  @Output() onPlayruleSelected = new EventEmitter<Tempo>();
  @Input() activeSlot!: TimeSlot;

  constructor() {
  }

  ngOnInit(): void {
    this.playlistMw$.subscribe((playlistsMw: EventFamily[]) => {
      this.playlistsFamilies = playlistsMw.filter(playlist => playlist.name !== 'Schedule' && playlist.name !== 'MY PLAYLISTS');
    });
    this.playrules$.subscribe((tempos: Tempo[]) => {
      this.playrules = tempos;
    });
  }

  selectPlaylistForSlot(playlist: EventFamily) {
    this.onPlaylistSelected.emit(playlist);
  }

  selectPlayruleForSlot(playrule: Tempo) {
    this.onPlayruleSelected.emit(playrule);
  }
}
